





















































































import ServiceDetailComponent from "@c/Home/Services/ServiceAppoint/ServiceDetail/ServiceDetailComponent";
export default ServiceDetailComponent;
